let shape = {};

export default shape;
